import { render } from "./RouteCode.vue?vue&type=template&id=12c53e3f"
import script from "./RouteCode.vue?vue&type=script&lang=js"
export * from "./RouteCode.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__